<template>
  <Slideover :visible="visible" size="max-w-2xl">
    <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
      <div class="flex items-start justify-between space-x-3">
        <h2 class="text-lg leading-7 font-medium">
          {{ title }}
        </h2>
        <div class="h-7 flex items-center">
          <button
            type="button"
            aria-label="Close panel"
            @click="$emit('toggle-slideover')"
            class="text-green-300 hover:text-white transition ease-in-out duration-150"
          >
            <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
          </button>
        </div>
      </div>
    </header>

    <!-- Slideover Body -->
    <div class="relative px-4 py-2">
      <div class="my-4 text-center text-lg leading-6 font-medium text-gray-900">
        <p class="mb-6">No items Print Date need to be cleared.</p>
        <p class="mb-6">Click Save to release the order.</p>
      </div>

      <!-- Errors -->
      <div class="pt-4 flex justify-end">
        <span v-if="error" class="text-red-500">Something went wrong!</span>
      </div>

      <!-- Buttons -->
      <div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <Button
            class="btn btn-white"
            v-on:click-handler="$emit('toggle-slideover')"
          >
            Cancel
          </Button>
        </span>

        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <Button
            v-on:click-handler="releaseHold()"
            :disabled="saving"
            class="flex items-center space-x-2"
          >
            <span>Save</span>
            <LoadingSpinner v-if="saving" class="text-white" />
          </Button>
        </span>
      </div>
    </div>
  </Slideover>
</template>

<script>
import Slideover from "@/components/layout/Slideover.vue";
import dateFormatter from "@/mixins/dateFormatter";
import Button from "@/components/elements/Button.vue";

export default {
  name: "OrderRelease",
  components: {
    Slideover,
    Button
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saving: false,
      reasons: [],
      reasonsLoaded: false,
      processing: false,
      error: false,
      clearPrintDates: []
    };
  },
  mixins: [dateFormatter],
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
    orderDetails() {
      if (!this.order.details) {
        return [];
      }

      return this.order.details
        .filter(product => {
          if (product.Adjustment != "0") {
            return false;
          }

          if (product.Type == "P") {
            return false;
          }

          if (product.variant.product.type.toLowerCase() == "internal") {
            return false;
          }

          if (product.variant.product.subcategory == "Warranty") {
            return false;
          }

          if (!product.DateShipped) {
            return false;
          }

          return true;
        })
        .map(product => {
          product.children = this.order.details.filter(
            child => child.Type == "P" && product.ItemNumber == child.Parent
          );
          return product;
        });
    }
  },
  created() {},
  methods: {
    releaseHold() {
      this.saving = true;

      this.$store
        .dispatch("orders/releaseOrder", {
          OrderNumber: this.order.SourceOrderNumber,
          data: { clearPrintDates: this.clearPrintDates }
        })
        .then(() => {
          this.$emit("update-row");
          this.$emit("toggle-slideover");
        })
        .catch(e => {
          this.isError = true;
          this.errorMsg = e.message;
          this.errorResponse = e.response.data;
        })
        .finally(() => {
          this.saving = false;
        });
    }
  },
  filters: {
    longMonth: dateFormatter.format
  }
};
</script>
<style scoped lang="scss">
th {
  @apply px-2 py-2 bg-gray-200 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider;
}
</style>
